import {Component} from '@angular/core';
import {TrendingCutPage} from "../../pages/trending-cut/trending-cut";
import {Events, NavController, NavParams} from "ionic-angular";
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";

/**
 * Generated class for the TrendingCutsGridComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'trending-cuts-grid',
    templateUrl: 'trending-cuts-grid.html'
})
export class TrendingCutsGridComponent {

    errors: {};
    loading: boolean;
    // Setup empty array of objects to have placeholders on page load
    trendingCuts: any = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];

    constructor(public navCtrl: NavController, public navParams: NavParams, public events: Events, private http: HttpClient, private apiErrorHandler: ApiErrorHandlerProvider) {
        events.subscribe('trendingCuts:refresh', () => {
            this.getTrendingCuts();
        })
    }

    ngOnInit() {
        this.getTrendingCuts();
    }

    getTrendingCuts() {
        this.loading = true;

        this.http.get('/trending-cuts')
            .subscribe(trendingCuts => {
                this.trendingCuts = trendingCuts;
                this.loading = false;
            }, error => {
                this.loading = false;
                this.errors = this.apiErrorHandler.handleError(error);
            })
    }

    openPage(event: any, trendingCut: object) {
        this.navCtrl.push(TrendingCutPage, {
            trendingCuts: this.trendingCuts,
            trendingCut: trendingCut
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/trending-cuts-grid/trending-cuts-grid.ts